import { formatPhoneNumberToE164, validatePhoneNumber } from '@occc/utils-phone-number';

export const sanitizePhoneNumberInFilterTextIfPresent = (
  filterText?: string,
): string | undefined => {
  if (!filterText) {
    return;
  }
  if (!validatePhoneNumber(filterText)) return filterText;

  const phoneNumber = formatPhoneNumberToE164(filterText);

  if (!phoneNumber) {
    return filterText;
  }

  return phoneNumber;
};
